<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding"
                 color="white" flat fixed app>
        <v-btn icon @click="$router.go(-1)">
          <v-icon size="32px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">북마크</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="pa-0 card-shadow">
          <v-card-title class="px-3" style="padding-top: 12px; padding-bottom: 12px;">
            <span style="font-weight: 700; font-size: 16px; letter-spacing: -0.3px; color: black;">
              저장한 컨텐츠 <span style="color: #ec2f54;">{{ bookmark_cnt }}</span>개
            </span>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="bookmarks.length">
        <template v-for="post of bookmarks">
          <VlogListCard v-if="post.type === 'video'"
                        :key="post.idx"
                        :videoId="post.video_id"
                        :postIdx="post.idx"
                        :type="post.type"
                        :createdAt="post.created_at"
                        :updatedAt="post.updated_at"
                        :menuIdx="post.menu_idx"
                        :nationIdx="post.nation_idx"
                        :title="post.title"
                        :contents="post.contents"
                        :thumbnail="post.thumbnail"
                        :imageList="post.image_list"
                        :bookmarks="post.bookmarks"
                        :channel="post.channels"
                        :viewCnt="post.view_cnt"
                        :likeCnt="post.like_cnt"
                        :likes="post.likes"
                        :commentCnt="post.comment_cnt"
                        @like="likePost(post.idx)"
                        @bookmark="bookmarkPost(post.idx)"
          />
          <PostListCard v-else
                        :key="post.idx"
                        :postIdx="post.idx"
                        :type="post.type"
                        :createdAt="post.created_at"
                        :updatedAt="post.updated_at"
                        :menuIdx="post.menu_idx"
                        :menuName="post.menus ? post.menus.name : null"
                        :nationIdx="post.nation_idx"
                        :nationName="post.nations ? post.nations.name : null"
                        :title="post.title"
                        :contents="post.contents"
                        :thumbnail="post.thumbnail"
                        :imageList="post.image_list"
                        :bookmarks="post.bookmarks"
                        :user="post.user"
                        :viewCnt="post.view_cnt"
                        :likeCnt="post.like_cnt"
                        :likes="post.likes"
                        :commentCnt="post.comment_cnt"
                        @like="likePost(post.idx)"
                        @bookmark="bookmarkPost(post.idx)"
          />
        </template>
      </v-flex>

      <template v-else>
        <v-flex>
          <div style="color: #9b9b9b;" class="my-5">
            <div class="mb-3">저장한 컨텐츠가 없습니다.</div>
            <div>
              마음에 드는 컨텐츠가 있다면<br>
              북마크<v-icon size="20px">$vuetify.icons.bookmarkOutlined</v-icon>를 눌러 저장하세요.
            </div>
          </div>
        </v-flex>
      </template>

    </v-layout>
  </v-container>
</template>

<script>
  import VlogListCard from '@/components/VlogListCard';
  import PostListCard from "@/components/PostListCard";
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'Bookmarks',
    components: { VlogListCard, PostListCard },
    computed: {
      ...mapGetters('user', { userIdx: 'idx', bookmarks: 'bookmarks', bookmark_cnt: 'bookmark_cnt' }),
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        scrollY: 0,
        page: 1,
        bottom: true,
      };
    },
    created () {
      this.selectBookmarks({ second: this.time, userIdx: this.userIdx, page: this.page }).then(() => {
        this.page++;
      });
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.selectBookmarks({ second: this.time, userIdx: this.userIdx, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
    },
    methods: {
      ...mapMutations('user', {
        mutationToggleBookmark: 'TOGGLE_BOOKMARK_POST',
        mutationToggleLike: 'TOGGLE_LIKE_POST',
      }),
      ...mapActions('post', [ 'toggleLike', 'toggleBookmark' ]),
      ...mapActions('user', [ 'selectBookmarks' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
        this.bottomVisible();
      },
      likePost (idx) {
        this.toggleLike(idx).then(response => {
          this.mutationToggleLike({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bookmarkPost (idx) {
        this.toggleBookmark(idx).then(response => {
          this.mutationToggleBookmark({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }
</style>
